// Assuming the common ancestor is the document, but you can use a closer parent if possible.
document.addEventListener('DOMContentLoaded', function () {
	const mjForm = document.querySelector('.mj-form');

	// jQuery('#mj-form__start-date').datepicker({
	// 	showOtherMonths: true,
	// 	format: 'dd-mm-yyyy'
	// });

	// jQuery('#mj-form__end-date').datepicker({
	// 	showOtherMonths: true,
	// 	format: 'dd-mm-yyyy'
	// });

	// jQuery('.mj-form-date').datepicker({
	// 	showOtherMonths: true,
	// 	format: 'dd-mm-yyyy'
	// });

	flatpickr("#mj-form__start-date", {
		enableTime: false,
		dateFormat: "d-m-Y", // Displays: 2017-01-22Z
	});

	flatpickr("#mj-form__end-date", {
		enableTime: false,
		dateFormat: "d-m-Y", // Displays: 2017-01-22Z
	});

	if (mjForm && typeof Datepicker !== 'undefined') {
		// Event delegation for start date, end date, and date input fields
		mjForm.addEventListener('focus', function (event) {
			const target = event.target;

			// Check if the focused element is the start date field
			if (target.matches('#mj-form__start-date')) {
				// new Datepicker(target, {
				// 	format: 'dd-mm-yyyy'
				// });
			}



			// Check if the focused element is the end date field
			if (target.matches('#mj-form__end-date')) {
				new Datepicker(target, {
					autoclose: true
				});
			}

			// Check if the focused element is a date input inside an element with class 'mj-form__date-wrapper'
			if (target.matches('.mj-form__date')) {
				//alert("dsdsa");
				new Datepicker(target, {
					autoclose: true,
				});
			}
		}, true); // Use capturing phase to handle the event before it reaches the target
	}
});